import { Button } from "@/shared/components/Button";
import { useEmailVerificationRequiredViewModel } from "../../viewmodel/useEmailVerificationRequiredViewModel";
import { useInlineLoading } from "@/shared/loading";
import styles from "./EmailVerificationRequiredPage.module.css";

export const EmailVerificationRequiredForm = () => {
  const { email, isLoading, handleResend, goToLogin } = useEmailVerificationRequiredViewModel();

  const BUTTON_ID = "resend-verification-button";
  const { isLoading: isInlineLoading } = useInlineLoading(BUTTON_ID);
  const buttonLoading = isLoading || isInlineLoading;

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Verify your email</h1>

        <p className={styles.info}>Your email is not verified yet.</p>

        <p className={styles.description}>
          Please verify your email to continue using the platform.
        </p>

        <p className={styles.helper}>
          Didn’t receive the email? You can resend the verification link below.
        </p>

        <div className={styles.inputGroup}>
          <label>Email</label>
          <input type="email" value={email} disabled className={styles.input} />
        </div>

        <Button
          data-testid={`${BUTTON_ID}-button`}
          onClick={handleResend}
          className={styles.primaryBtn}
          disabled={buttonLoading}
        >
          {buttonLoading ? "Resending..." : "Resend Verification Email"}
        </Button>

        <p className={styles.footer}>
          Already verified?{" "}
          <span onClick={goToLogin} className={styles.link}>
            Login
          </span>
        </p>
      </div>
    </div>
  );
};
